import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { CountryList, MerchantField } from "../../types";

// only add a default value during jest testing
const defaultValue: CountryList | undefined = process.env.JEST_WORKER_ID
  ? "United States"
  : undefined;

export const SupportedCountries: CountryList[] = [
  "United States",
  "Australia",
  "New Zealand",
  "United Kingdom",
  "Canada",
];

export const CountryCodeToCountryMap: Record<string, CountryList> = {
  US: "United States",
  AU: "Australia",
  NZ: "New Zealand",
  UK: "United Kingdom",
  GB: "United Kingdom",
  CA: "Canada",
};

export const CountryToCountryCodeMap: Record<CountryList, string> = {
  "United States": "US",
  Australia: "AU",
  "New Zealand": "NZ",
  "United Kingdom": "UK",
  Canada: "CA",
};

export class RegisteredCountryField extends Field<CountryList> {
  constructor(model: Merchant, opts: Partial<MerchantField<CountryList>> = {}) {
    super(model, {
      dataType: "string",
      propertyName: "registeredCountry",
      uiFieldType: "Select",
      pickList: SupportedCountries,
      applicable: true,
      required: true,
      shown: true,
      value: defaultValue,
      ...opts,
    });
  }
}
